module.exports = __webpack_public_path__ + "static/media/galerija_2017 (34).fec7ca1c.jpg";